App.ThemesController = Em.Controller.extend
  notifier: Em.inject.service()

  organization: null
  themes: null

  skinsBinding: 'model'
  isSelectingTheme: false

  # Текущий выбранный скин (может отсутствовать!)
  selectedSkins: Em.computed.filterBy('skins', 'is_selected', true)
  selectedSkinBinding:  'selectedSkins.firstObject'

  selectSkinIsLoading: false
  publishIsLoading: false

  previewComponent: null

  selectSkin: (skin) ->
    @get('skins').forEach (skin) -> skin.set('is_selected', false)
    skin.set('is_selected', true)
    skin.select()

  actions:
    goBackToSettings: ->
      @set('isSelectingTheme', false)
      false

    refreshPreview: ->
      @get('previewComponent').send('reload')

    startThemeSelection: ->
      @set('isSelectingTheme', true)


    publishCurrentSkin: ->
      skin = @get('selectedSkin')
      return unless skin

      @set('publishIsLoading', true)
      skin.publish().finally =>
        @get('notifier').pushNotification
          type: 'success'
          # todo i18n
          title: 'Опубликовано'
          message: "#{skin.get('theme.title')} опубликована на сайте ресторана"
          duration: 5000
        @set 'publishIsLoading', false

    selectSkin: (skin) ->
      return if @get('selectSkinIsLoading')

      @set('selectSkinIsLoading', true)
      @selectSkin(skin).finally =>
        @set 'selectSkinIsLoading', false
        @set('isSelectingTheme', false)

    gotoAddressChange: ->
      @transitionToRoute('settings.organization.host')
      false
